import { FC } from "react";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";
import {
    DashboardCollapse,
    DashboardCollapseItemType,
    DashboardCollapseListItem,
} from "@/pages/Dashboard/components/DashboardCollapse";
import { DashboardProgress } from "@/pages/Dashboard/components/DashboardProgress";

import { StyledMMLValue } from "./Styled";

interface IMMLCollapseProps {
    targetDB: "db-sv" | "db-ta";
}

export const MMLCollapse: FC<IMMLCollapseProps> = ({ targetDB }) => {
    const workState = useAppSelector((state) => state.work);
    const svState = useAppSelector((state) => state.sv);
    const { salary, motivation } = targetDB === "db-sv" ? svState : workState;
    const mmlStatistics = motivation?.mml;
    const items: DashboardCollapseListItem[] = [
        {
            label: "Загальна кількість точок * СКЮ:",
            value: mmlStatistics?.statistic?.plan || 0,
            type: "basic",
        },
        {
            label: "Виконано точок * СКЮ:",
            value: mmlStatistics?.statistic?.fact || 0,
            type: "basic",
        },
        {
            label: "Відсоток виконання:",
            value: `${mmlStatistics?.statistic?.percent || 0}%`,
            type: "basic",
        },
        {
            label: "Зараховується від:",
            value: `${mmlStatistics?.configuration?.minComplete || 0}%`,
            type: "basic",
        },
        {
            label: "Коефіцієнт бонусу:",
            value: mmlStatistics?.configuration?.bonusCoefficient || 0,
            type: "basic",
        },
        // {
        //     label: "Коефіцієнт штрафу:",
        //     value: mmlStatistics?.configuration?.fineCoefficient || 0,
        //     type: "basic",
        // },
        ...(mmlStatistics?.configuration?.fineCoefficient !== 1 && [
            {
                label: "Коефіцієнт штрафу:",
                value: mmlStatistics?.configuration?.fineCoefficient || 0,
                type: "basic" as DashboardCollapseItemType,
            },
        ]),

        {
            label: "Вплив MML:",
            value: `${salary?.mmlBonus || 0} грн.`,
            type: "basic",
        },
    ];

    return (
        <DashboardCollapse
            header={
                <FlexContainer
                    width="100%"
                    flexDirection="column"
                    gap="4px"
                    alignItems="flex-start"
                    justifyContent="flex-start"
                >
                    <FlexContainer
                        width="100%"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <PrimaryText fontWeight="400" fontSize={14}>
                            Виконання MML Стандарту:
                        </PrimaryText>
                        <StyledMMLValue fontWeight="500" fontSize={16}>
                            {salary?.mmlBonus || 0} грн.
                        </StyledMMLValue>
                    </FlexContainer>

                    <DashboardProgress
                        value={Math.round(
                            mmlStatistics?.statistic?.percent || 0,
                        )}
                        limit={mmlStatistics?.configuration?.minComplete || 0}
                    />
                </FlexContainer>
            }
            items={items}
        />
    );
};
